if ( typeof CrossSellRecommendations !== 'function' ) {
	window.CrossSellRecommendations = class extends HTMLElement {
		constructor() {
          super();
          this.loaded = false;
          
          const handleIntersection = (entries, observer) => {
            if (entries[0].isIntersecting && !this.loaded) {
              this.loaded = true;
              observer.unobserve(this);
              this.loadContent();
            }
          }

          // Wait for DOM connection
          setTimeout(() => {
            if (this.dataset.url) {
              new IntersectionObserver(handleIntersection, {
                rootMargin: '0px 0px 400px 0px',
                threshold: 0.01
              }).observe(this);
            }
          }, 0);
		}

    loadContent() {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const innerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('cross-sell-recommendations');

          if (innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0) {
            this.innerHTML = innerHTML.innerHTML;
            this.dispatchEvent(new Event('cross-sell-recommendations-loaded'));
          } else {
            this.dispatchEvent(new Event('product-recommendations-error'));
          }
        })
        .catch(() => this.dispatchEvent(new Event('product-recommendations-error')));
    }
	}
	
    if ( typeof customElements.get('cross-sell-recommendations') == 'undefined' ) {
        customElements.define('cross-sell-recommendations', window.CrossSellRecommendations);
    }
}